export default "__VITE_ASSET__BcgSijB3__"